module.exports = __webpack_public_path__ + "static/media/install-run-jest.00d4bf91.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/presentations/expect-more/assets/install-run-jest.mp4
// module id = 673
// module chunks = 0